import { EntityTypesSupportedByMapsPage } from "@mapmycustomers/shared/types/entity";
import { ColorPinLegend, ShapePinLegend } from "@mapmycustomers/shared/types/map/PinLegend";
import MapViewState from "@mapmycustomers/shared/types/viewModel/MapViewState";
import { PinLegendsFilter } from "@mapmycustomers/shared/types/viewModel/platformModel/PlatformFilterModel";

import { getLocalTimeZoneFormattedOffset } from "@app/util/dates";
import getColorShapeForEntity from "@app/util/map/markerStyles/getColorShapeForEntity";

const buildPinLegends = (
  entityTypes: EntityTypesSupportedByMapsPage[],
  viewState: Pick<MapViewState, "colorKey" | "shapeKey">,
  colorPinLegends: ColorPinLegend[],
  shapePinLegends: ShapePinLegend[]
): PinLegendsFilter =>
  entityTypes.reduce(
    (result, entityType) => ({
      ...result,
      [entityType]: getColorShapeForEntity(viewState, colorPinLegends, shapePinLegends, entityType),
    }),
    { $offset: getLocalTimeZoneFormattedOffset() } as PinLegendsFilter
  );

export default buildPinLegends;
